export function formatDate(
  isoDateString: string,
  locale: string = 'en',
  isUTC: boolean = true,
): string {
  const date = new Date(isoDateString)
  if (isNaN(date.getTime())) return ''

  const dateFormatter = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    // ...(isUTC ? { timeZone: 'UTC' } : {}), // NOTE was removed due to incorrect date from string like Aug 15
  })

  const parts = dateFormatter.formatToParts(date)
  const getPartValue = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? ''

  return `${getPartValue('month')} ${getPartValue('day')}, ${getPartValue('year')}`.trim()
}
